import { Button, TextField, Typography, Checkbox, FormControlLabel } from '@mui/material';
import Box from '@mui/material/Box';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import GeneralDatePickerComponent from '../../components/GeneralDatePickerComponent';
import { useNavigate } from 'react-router-dom';
import ShareIcon from '@mui/icons-material/Share';
import Dropdown from './DropdownFilter';
import { DropdownOptions } from './DropdownOptions';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

interface INewReceiptSingleRow {
    data?: any[];
    updateTotalValue: (v: number | string) => void;
    id?: string;
}

const SingleRow: React.FC<INewReceiptSingleRow> = ({ data = [], id = '1', updateTotalValue }) => {
    const [nameOnReceipt, setNameOnReceipt] = useState<string>('');
    const [kartesetValue, setKartesetValue] = useState<string>('0');
    const [receiptNumbers, setReceiptNumbers] = useState<string>('');
    const [filteredData, setFilteredData] = useState(data);
    const [tashlumim, setTashlumim] = useState(() => [{ value: '', method: 'cash' }]);

    const inputRefs = useRef<(HTMLInputElement | null)[]>([]); // Store references to input fields

    const navigate = useNavigate();

    const handleShareClick = () => {
        console.log('Share Icon Clicked');
    };

    const handleAddPayment = () => {
        setTashlumim([...tashlumim, { value: '', method: 'cash' }]);
    };

    const handlePaymentChange = (index: number, newValue: string) => {
        setTashlumim((prev) => {
            const updated = prev.map((entry, i) => (i === index ? { ...entry, value: newValue } : entry));
            return updated;
        });
    };
    // Use useCallback to prevent unnecessary function re-creation
    const calculateTotal = useCallback(() => {
        const total = tashlumim.reduce((sum, entry) => sum + (parseFloat(entry.value) || 0), 0);
        updateTotalValue(total);
    }, [tashlumim, updateTotalValue]);

    useEffect(() => {
        calculateTotal(); // Calculate total whenever tashlumim changes
    }, [tashlumim, calculateTotal]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '50px',
                minHeight: 'calc(100vh - 150px)',
                padding: '20px'
            }}
        >
            <Typography sx={{ alignSelf: 'center', fontSize: '25px' }}>קבלה חדשה</Typography>
            {/** customer text field */}
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <Typography sx={{ fontSize: '12px', color: 'black', whiteSpace: 'nowrap' }}>לכבוד</Typography>
                    <TextField
                        type="text"
                        variant="standard"
                        size="small"
                        placeholder="שם לקוח"
                        value={nameOnReceipt}
                        onChange={(e) => {
                            const newValue = e.target.value;
                            setNameOnReceipt(newValue);
                        }}
                    />
                </Box>
            </Box>
            {/** date */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography sx={{ fontSize: '16px', color: 'black', whiteSpace: 'nowrap' }}>תאריך מסמך</Typography>
                <GeneralDatePickerComponent singleDateMode={true} mainContent={filteredData} setDisplayedData={setFilteredData} />
            </Box>
            {/** karteset */}
            <Box sx={{ display: 'flex', gap: '22%', alignItems: 'center', width: '100%' }}>
                <Button
                    sx={{ backgroundColor: 'blue !important', color: 'white', minWidth: 'fit-content' }}
                    onClick={() => navigate(`/karteset?id=${id}`)}
                >
                    פתח כרטסת
                </Button>
                <TextField
                    type="text"
                    variant="standard"
                    size="small"
                    sx={{ width: '100%' }}
                    value={kartesetValue}
                    onChange={(e) => {
                        const newValue = e.target.value;
                        if (/^\d*\.?\d*$/.test(newValue)) setKartesetValue(newValue);
                    }}
                />
            </Box>
            {/** heshbonit mas */}
            <Box
                sx={{
                    display: 'flex',
                    maxHeight: '50px',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
            >
                <Typography
                    sx={{
                        display: 'flex',
                        fontSize: '16px',
                        color: 'black',
                        lineHeight: '15px',
                        flexGrow: 1
                    }}
                >
                    מילוי לפי חשבונית מס(לא חובה)
                </Typography>
                <Box sx={{ display: 'flex', gap: '10px' }}>
                    <ShareIcon onClick={handleShareClick} style={{ cursor: 'pointer' }} />
                </Box>
            </Box>
            {/** heshbonit mas 2 */}
            <Box sx={{ display: 'flex', gap: '22%', alignItems: 'center', width: '100%' }}>
                <Button sx={{ backgroundColor: 'blue', color: 'white', minWidth: 'fit-content' }} onClick={() => console.log('click!')}>
                    בחר חשבונית מס
                </Button>
                <TextField
                    type="text"
                    variant="standard"
                    size="small"
                    sx={{ width: '100%' }}
                    value={receiptNumbers}
                    placeholder={'מספרי חשבוניות'}
                    onChange={(e) => {
                        const newValue = e.target.value;
                        setReceiptNumbers(newValue);
                    }}
                />
            </Box>

            {/** Tashlumim */}
            {tashlumim.map((entry, index) => (
                <Box key={index} sx={{ display: 'flex', gap: '22%', alignItems: 'center', width: '100%' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography sx={{ fontSize: '12px', color: 'black', whiteSpace: 'nowrap' }}>תשלום מספר {index + 1}</Typography>
                        <TextField
                            inputRef={(el) => (inputRefs.current[index] = el)} // Store ref
                            type="text"
                            variant="standard"
                            size="small"
                            sx={{ width: '100%' }}
                            value={entry.value ?? ''}
                            placeholder={'סכום תשלום(ש״ח)'}
                            onChange={(e) => handlePaymentChange(index, e.target.value)}
                        />
                    </Box>
                    <Dropdown options={DropdownOptions} />
                </Box>
            ))}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '20px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingBottom: '15px'
                }}
            >
                <Box display="flex" flexDirection="row">
                    <AddCircleOutlineIcon fontSize="small" onClick={handleAddPayment} />
                    <Typography>הוסף תשלום</Typography>
                </Box>
                <Box display="flex" flexDirection="row">
                    <ContentCopyIcon fontSize="small" onClick={handleShareClick} />
                    <Typography>העתק תשלום</Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default SingleRow;
